export const languages = {
  de: 'Deutsch'
} as const;

export type Language = keyof typeof languages;

export const defaultLanguage: Language = 'de';

export const languageConfig = {
  de: {
    code: 'de',
    name: 'Deutsch',
    locale: 'de-CH',
    flag: '🇨🇭',
    currency: 'CHF'
  }
} as const;

// Helper function to get language from URL
export function getLanguageFromUrl(url: URL): Language {
  const [, lang] = url.pathname.split('/');
  if (lang in languages) {
    return lang as Language;
  }
  return defaultLanguage;
}

// Helper function to switch language in URL
export function switchLanguageUrl(currentUrl: URL, newLang: Language): string {
  const parts = currentUrl.pathname.split('/');
  const currentLang = parts[1];

  if (currentLang in languages) {
    parts[1] = newLang;
  } else {
    parts.splice(1, 0, newLang);
  }

  return parts.join('/');
}
